<template>	
    <tabs class="my-tabs">
        <tab title="全部" :callback="tabClick">
        	<ArticleListAll :dataType="dataType"></ArticleListAll>
        </tab>
        <tab title="已发布" :callback="tabClick">
        	<ArticleListReleased :dataType="dataType"></ArticleListReleased>
        </tab>
        <tab title="审核中" :callback="tabClick">
        	<ArticleListAudit :dataType="dataType"></ArticleListAudit>
        </tab>
        <tab title="未通过" :callback="tabClick">
        	<ArticleListNoPass :dataType="dataType"></ArticleListNoPass>
        </tab>
        <tab title="草稿" :callback="tabClick">
        	<ArticleListDraft :dataType="dataType"></ArticleListDraft>
        </tab>
        <tab title="已撤回" :callback="tabClick">
        	<ArticleListRetract :dataType="dataType"></ArticleListRetract>
        </tab>
    </tabs>
	
</template>
<script>
	import {Tabs, Tab} from './../../common/js/TabComponent.js';
    import ArticleListAll from './articleList.vue';
    import ArticleListReleased from './articleList.vue';
    import ArticleListAudit from './articleList.vue';
    import ArticleListNoPass from './articleList.vue';
    import ArticleListDraft from './articleList.vue';
	import ArticleListRetract from './articleList.vue';
	export default {
	  	data() {
		    return {
                dataType: 0,
		    }
	  	},
	  	components: {
		    Tabs,
		    Tab,
            ArticleListAll,
            ArticleListReleased,
            ArticleListAudit,
            ArticleListNoPass,
            ArticleListDraft,
		    ArticleListRetract,
  		},      
        mounted(){
            // console.log(this.tabTitle)
        },
        methods: {
            tabClick (e, index){
                // console.log(arguments)
                this.dataType = index;
            }
        }
	}
</script>
<style src="./../../common/css/pagearticleTab.css"></style>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/pagearticle/tab.vue